import { H2, H3, H3KR, SubtitleL, BB } from 'global-styles';
import styled, { css } from 'styled-components';
import visionImg from 'public/asset/about/03-section3/section3-img.png';
import { useRouter } from 'next/router';
import { txtAnimation } from 'components/Home/BannerItems';
import { ImgBackgroundWrapper } from 'components/Common/CommonWrappers';
import Image from 'next/image';

const VisionTopKo = () => (
  <>
    <div className="vision-top-pc">
      <SubtitleL className="sub-t">
        <div className="anim-wrapper">
          블루닷은 효율적인 비용으로 네트워크 환경에서 최적의
        </div>
      </SubtitleL>
      <SubtitleL className="sub-t">
        <div className="anim-wrapper">
          화질로 동영상 스트리밍 서비스를 가능하게 함으로써
        </div>
      </SubtitleL>
    </div>

    <div className="vision-top-mo">
      <SubtitleL className="sub-t">
        <div className="anim-wrapper">블루닷은 효율적인 비용으로 네트워크</div>
      </SubtitleL>
      <SubtitleL className="sub-t">
        <div className="anim-wrapper">환경에서 최적의 화질로 동영상</div>
      </SubtitleL>
      <SubtitleL className="sub-t">
        <div className="anim-wrapper">스트리밍 서비스를 가능하게 함으로써</div>
      </SubtitleL>
    </div>
  </>
);
const VisionBotKo = () => (
  <>
    <div className="vision-top-pc">
      <VisionH3KR>
        <div className="anim-wrapper">
          서비스 기업에게는 <span>비용 절감</span>을
        </div>
      </VisionH3KR>
      <VisionH3KR>
        <div className="anim-wrapper">
          그리고 사용자에게는
          <span> 향상된 시청 경험</span>을
        </div>
      </VisionH3KR>
      <VisionH3KR>
        <div className="anim-wrapper">제공하는데 기여하고자 합니다.</div>
      </VisionH3KR>
    </div>

    <div className="vision-top-mo">
      <VisionH3KR>
        <div className="anim-wrapper">
          서비스 기업에게는 <span>비용 절감</span>을
        </div>
      </VisionH3KR>
      <VisionH3KR>
        <div className="anim-wrapper">
          그리고 사용자에게는
          <span> 향상된</span>
        </div>
      </VisionH3KR>
      <VisionH3KR>
        <div className="anim-wrapper">
          <span>시청 경험을 </span>제공하는데
        </div>
      </VisionH3KR>
      <VisionH3KR>
        <div className="anim-wrapper">기여하고자 합니다.</div>
      </VisionH3KR>
    </div>
  </>
);

const VisionTopEn = () => (
  <>
    <div className="vision-top-pc">
      <SubtitleL className="sub-t">
        <div className="anim-wrapper">
          BLUEDOT aims to contribute to cost reduction for Service Providers
        </div>
      </SubtitleL>
      <SubtitleL className="sub-t">
        <div className="anim-wrapper">
          and an improved viewing experience for Service Users
        </div>
      </SubtitleL>
    </div>
    <div className="vision-top-mo">
      <SubtitleL className="sub-t">
        <div className="anim-wrapper">BLUEDOT aims to contribute to cost</div>
      </SubtitleL>
      <SubtitleL className="sub-t">
        <div className="anim-wrapper">reduction for Service Providers and</div>
      </SubtitleL>
      <SubtitleL className="sub-t">
        <div className="anim-wrapper">an improved viewing experience for</div>
      </SubtitleL>
      <SubtitleL className="sub-t">
        <div className="anim-wrapper">Service Users</div>
      </SubtitleL>
    </div>
  </>
);
const VisionBotEn = () => (
  <>
    <div className="vision-top-pc">
      <VisionH3>
        <div className="anim-wrapper">
          by enabling video streaming services with
        </div>
      </VisionH3>
      <VisionH3>
        <div className="anim-wrapper">
          <span>Optimal Video Quality </span>
          in a given network
        </div>
      </VisionH3>
      <VisionH3>
        <div className="anim-wrapper">
          environment at
          <span> an Efficient Cost.</span>
        </div>
      </VisionH3>
    </div>

    <div className="vision-top-mo">
      <VisionH3>
        <div className="anim-wrapper">by enabling video</div>
      </VisionH3>
      <VisionH3>
        <div className="anim-wrapper">streaming services with</div>
      </VisionH3>
      <VisionH3>
        <div className="anim-wrapper">
          <span>Optimal Video Quality </span>
          in a
        </div>
      </VisionH3>
      <VisionH3>
        <div className="anim-wrapper">given network environment</div>
      </VisionH3>
      <VisionH3>
        <div className="anim-wrapper">
          at an
          <span> Efficient Cost.</span>
        </div>
      </VisionH3>
    </div>
  </>
);

interface Props {
  isVisible: boolean;
  // targetRef: MutableRefObject<HTMLElement>;
  targetRef: (node?: Element) => void;
}

export const OurVision = ({ isVisible, targetRef }: Props) => {
  const { locale } = useRouter();

  return (
    <OurVisionContainer ref={targetRef} isVisible={isVisible}>
      <div className="o-v-inner-wrapper">
        <ImgBackgroundWrapper>
          <Image
            src={visionImg}
            layout="fill"
            objectFit="cover"
            alt=""
            className="target-img"
            quality={85}
            sizes="(min-width: 906px) 90vw,
                 (min-width: 600px) 85vw,
                 (max-width: 599px) 75vw"
          />
        </ImgBackgroundWrapper>
        <H2 className="vision-title">Our Vision</H2>

        <div className="vision-top">
          {locale === 'en' ? <VisionTopEn /> : <VisionTopKo />}
        </div>

        <div className="vision-bottom">
          {locale === 'en' ? <VisionBotEn /> : <VisionBotKo />}
        </div>
      </div>
    </OurVisionContainer>
  );
};

const VisionH3 = styled(H3)`
  overflow-y: hidden;
  span {
    color: ${BB};
  }
`;
const VisionH3KR = styled(H3KR)`
  font-weight: 700;
  overflow-y: hidden;
  span {
    color: ${BB};
  }
`;

interface OurVisionContainerProps {
  isVisible: boolean;
}

const OurVisionContainer = styled.section<OurVisionContainerProps>`
  background: linear-gradient(180deg, #ffffff 0%, rgba(255, 255, 255, 0) 100%);
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  .o-v-inner-wrapper {
    width: 100%;
    height: 1080px;
    margin-top: 220px;
    position: relative;
  }
  .vision-title {
    margin: 4px 0 56px;
    text-align: center;
    opacity: 0;
    overflow-y: hidden;
  }
  .vision-top {
    margin: 0 0 146px 0;
  }
  .sub-t {
    overflow-y: hidden;
  }
  .anim-wrapper {
    opacity: 0;
  }
  .vision-top-mo {
    display: none;
  }

  @media screen and (max-width: 1439px) and (min-width: 1240px) {
    .o-v-inner-wrapper {
      margin-top: 160px;
    }
    .vision-title {
      margin: 64px 0 56px;
    }
    .vision-top {
      margin: 0 0 146px;
    }
  }
  @media screen and (max-width: 1239px) and (min-width: 905px) {
    .o-v-inner-wrapper {
      margin-top: 0;
    }
    .vision-title {
      margin: 178px 0 32px;
    }
    .vision-top {
      margin: 0 0 96px 0;
    }
  }
  @media screen and (max-width: 904px) and (min-width: 600px) {
    .o-v-inner-wrapper {
      height: 840px;
      margin-top: 0;
    }
    .vision-title {
      margin: 128px 0 16px;
    }
    .vision-top {
      margin: 0 0 56px 0;
    }
  }
  @media screen and (max-width: 599px) {
    .o-v-inner-wrapper {
      height: 760px;
      margin-top: 0;
    }
    .vision-title {
      margin: 88px 0 16px;
    }
    .vision-top {
      margin: 0 0 56px 0;
    }
    .vision-top-mo {
      display: block;
    }
    .vision-top-pc {
      display: none;
    }
  }

  ${({ isVisible }) =>
    isVisible &&
    css`
      .vision-title {
        animation: ${txtAnimation} 0.8s cubic-bezier(0.4, 0, 0.2, 1) forwards;
      }
      .vision-top {
        overflow-y: hidden;
        .anim-wrapper {
          animation: ${txtAnimation} 0.8s 0.2s cubic-bezier(0.4, 0, 0.2, 1)
            forwards;
        }
      }
      .vision-bottom {
        .anim-wrapper {
          animation: ${txtAnimation} 1.2s 0.4s cubic-bezier(0.4, 0, 0.2, 1)
            forwards;
        }
      }
    `};
`;
